import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { useStyle } from "../style";
import axios from "axios";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import _ from "lodash";
import CustomTextField from "../../../../../components/utils/input/customTextField";

const SalesInfo = ({options, setOptions,subData,setSubData,catData,setCatData, allSubData, setAllSubData,setPostData, postData, docName, setDocName ,data}) => {
  const classes = useStyle();
    const roleId = localStorage.getItem("role_id")

  const [supplierData, setSupplierData] = useState([]);
      const [supplier, setSupplier] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [address, setAddress] = useState("");
  const [gstIn, setGstIn] = useState("");
  const [mode, setMode] = useState("");
  const [balance, setBalance] = useState("0.00");
  const outletId = localStorage.getItem("outlet_id");
  const [totalQuantity, setTotalQuantity] = useState(0);
  const[cust, setCust] = useState(null)
    //   const [allSubData, setAllSubData] = useState([]);
  
    // const [catData,setCatData] = useState([])
    // const [subData,setSubData] = useState([])
    //   const [options, setOptions] = useState({
    //     customer : null,
    //     category : null,
    //     subCategory : null
    // })
  const dispatch = useDispatch();
  const [poDetails, setPoDetails] = useState({
    docDate: moment().format(),
    supplierId: null,
  });

  // const getSupplierData = () => {
  //   axios
  //     .get(`/v1/indent/order/outlet/wharehouse/list/${outletId}`)
  //     .then((res) => {
  //       // Find the warehouse with the given outletId
  //       const filteredWarehouse = res.data.find((warehouse) => warehouse.id === outletId);
  
  //       // If a match is found, set it to the state
  //       if (filteredWarehouse) {
  //         setCust(filteredWarehouse);
  //       } else {
  //         console.warn(`No warehouse found with id: ${outletId}`);
  //       }
  
  //       // Set all supplier data
  //       setSupplierData(res.data);
  //       console.log(res.data,"gstgstgstgst");
        
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       dispatch(setSnackbar(true, 'error', err.response?.data?.error || 'An error occurred while fetching supplier data'));
  //     });
  // };
  
  const handleSupplierChange = (event, value) => {
    const selectedSupplier = supplierData.find((supplier) => supplier.warehouse_name === value?.warehouse_name);
    setAddress(selectedSupplier ? `${selectedSupplier.warehouse_add1} ${selectedSupplier.warehouse_add2}, ${selectedSupplier.warehouse_add3}-
      `
       : '');
    setGstIn(selectedSupplier ? selectedSupplier.gstin : "");
    setBalance(selectedSupplier ? selectedSupplier.balance : "0.00");
    setPoDetails((prevState) => ({ ...prevState, supplierId: value }));
    setMode(value.outlet_type_name === "OWN" ? 'Transfer' : 'Sales');
    
 
  };

  const handleChange = (e) => {
    setPoDetails((prevState) => ({ ...prevState, docDate: dayjs(e).format() }));
  };
  function getPoData() {
    axios
      .get("/v1/indent/order")
      .then((res) => {
        setDocName(res.data.Docno); // Set the PO number to state
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  function handleOptions(value, name){
    console.log(name, value)
    // setOptions(prev=>({...prev,[name] : value}))
    setOptions((prev) => ({ ...prev, [name]: value }));
        if (name === "category") {
          setOptions((prev) => ({ ...prev, subCategory: null }));
          filterSubCategories(value ? value.id : null);
        }
}
function filterSubCategories(categoryId) {
  if (categoryId) {
    const filteredSubData = allSubData.filter(
      (sub) => sub.category_id === categoryId
    );
    setSubData(filteredSubData);
  } else {
    setSubData([]);
  }
}
  function getCategory(){
    axios.get('/v1/categories')
    .then(res=>{
        _.filter(res.data, val=>{
            if(val.is_active){
                 setCatData(res.data)
            }
        })
    })
    .catch(err=>{
        console.log(err)
        dispatch(setSnackbar(true,'error',err.response.data.error))
    })
}
function getSubCategory(){
    axios.get('/v1/subcategories')
    .then(res=>{
            // setSubData(res.data)
            setAllSubData(res.data);
    })
    .catch(err=>{
        console.log(err)
        dispatch(setSnackbar(true,'error',err.response.data.error))
    })
}
  // function getSupplierData() {
  //   axios
  //     .get("/v1/outlet/list/1")
  //     .then((res) => {
  //       console.log(res.data)
  //       setSupplier(res.data);
  //     })
  //     .catch((err) => {
  //       dispatch(setSnackbar(true, "error", err.response.data.error));
  //     });
  // }
  function getSupplierData() {
  axios
    .get("/v1/outlet/list/1")
    .then((res) => {
      console.log(res.data);
      setSupplier(res.data);

      const allOptions = [{ id: 0, fullname: "All" }, ...res.data];
      const defaultCustomer = allOptions.find(
        (item) => String(item.id) === String(outletId)
      );

      if (defaultCustomer) {
        setSelectedCustomer(defaultCustomer);
        handleOptions(defaultCustomer, "customer");  // Maintain your existing logic
      }
    })
    .catch((err) => {
      dispatch(setSnackbar(true, "error", err.response?.data?.error || "Error fetching supplier"));
    });
}

  useEffect(() => {
    getSupplierData();
    getPoData()
     getCategory()
    getSubCategory()
  }, []);

  // useEffect(() => {
  //   if (poDetails.supplierId !== null) {
  //     setPostData((prev) => ({
  //       ...prev,
  //       docdate: moment(poDetails.docDate).format('YYYY/MM/DD'),
        
  //       wh_id: Number(outletId), 
  //     }));
  //   }
  // }, [poDetails, setPostData,outletId]);
  useEffect(() => {
    if (poDetails.supplierId !== null) {
      setPostData((prev) => ({
        ...prev,
        docdate: moment(poDetails.docDate).format('YYYY/MM/DD'),
        wh_id: poDetails.supplierId.warehouse_id,  // Send warehouse ID (supplierId.id)
      }));
    }
  }, [poDetails, setPostData]);
  
  console.log(postData,"poDetails");
  
// useEffect(() => {
//     const total = data.reduce((sum, item) => sum + item.qty, 0);
//     setTotalQuantity(total);
//   }, [data]);
  useEffect(() => {
    // Calculate total quantity from the `data` array
    const total = data.reduce((sum, item) => sum + item.qty, 0);
    setTotalQuantity(total);
  
    // Update postData with the total quantity
    setPostData((prev) => ({
      ...prev,
      total_qty: total, // Add total quantity to postData
    }));
  }, [data, setPostData]);
  
    // Set default supplier based on outletId
 // Set default supplier based on outletId
 useEffect(() => {
  if (outletId && supplierData.length) {
    const defaultSupplier = 
    // supplierData.find(supplier => supplier.warehouse_id === parseInt(outletId));
    supplierData.find(supplier => supplier.warehouse_id === parseInt(outletId)) || supplierData[0];
    if (defaultSupplier) {
      setPoDetails(prevState => ({
        ...prevState,
        supplierId: defaultSupplier,
        docDate: moment().format(),
      }));
      setAddress(`${defaultSupplier.warehouse_add1} ${defaultSupplier.warehouse_add2},
         
         `);
      setGstIn(defaultSupplier.gstin);
      setBalance(defaultSupplier.balance);
      setMode(defaultSupplier.outlet_type_name === "OWN" ? 'Transfer' : 'Sales');

  
      axios.get('/v1/indent/order', )
        .then((res) => {
          if (res.data?.Docno) {
            // Log for debugging
            console.log("Fetched Docno on load:", res.data.Docno);
            setDocName(res.data.Docno);  // Set document number (docno) here
          } else {
            dispatch(setSnackbar(true, 'error', "Document number not found"));
          }
        })
        .catch((err) => {
          console.log(err);
          dispatch(setSnackbar(true, 'error', err.response?.data?.error || "Error fetching document number"));
        });
    }
  }
}, [outletId, supplierData,docName]);
  return (
    <Grid container spacing={2} className="p-2 h-full">
      {/* <Grid item lg={4}>
        <Autocomplete
          id="supplier"
          name="supplier"
          size="small"
          options={supplierData}
          getOptionLabel={(option) => option?.warehouse_name}
          value={poDetails.supplierId}
          onChange={handleSupplierChange}
          disableClearable
          isOptionEqualToValue={(option, value) => option.warehouse_name === value.warehouse_name}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Warehouse Name"
              autoComplete="off"
            />
          )}
        />
        <TextField size="small" label="Address" multiline rows={3.3} fullWidth sx={{ marginBlock: 1.5 }} value={address} InputProps={{ readOnly: true }} />
      </Grid> */}
     
      <Grid item md={3}>
        <TextField size="small" label="Indent No" fullWidth value={docName} InputProps={{ readOnly: true }} />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            onChange={(e) => handleChange(e)}
            value={dayjs(poDetails.docDate)}
            label="Date"
            slotProps={{
              textField: {
                size: "small",
              },
            }}
            sx={{ width: '100%', marginBlock: 1.5 }}
          />
        </LocalizationProvider>
         
      </Grid>
      
       <Grid item md={3}>
           <Autocomplete 
                size='small'
                value={options.category}
                options={[{id:0 , category_name :"All"} , ...catData]}
                // options={catData}
                getOptionLabel={option=>option.category_name}
                onChange={(e,value)=>handleOptions(value,'category')}
                renderInput={(params)=>(
                    <TextField {...params}
                    label='Category'/>
                  )}
                />
              </Grid>
              <Grid item md={3}>
              <Autocomplete
                size='small'
                options={subData}
                value={options.subCategory}
                disabled={options.category == null}
                getOptionLabel={option=>option.subcategory_name}
                onChange={(e,value)=>handleOptions(value,'subCategory')}
                renderInput={(params)=>(
                    <TextField {...params}
                    label='Sub Category'/>
                  )}
                />
              </Grid>
             {/* <Grid item md={3}>
                <Autocomplete 
                  size="small"
                  options={[{id:0 , fullname :"All"} , ...supplier]}
                  onChange={(e,value)=>handleOptions(value,'customer')}
                  getOptionLabel={option=>option.fullname}
                  disabled={(roleId != 1 && roleId != 2)} 
                  renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
                />
              </Grid> */}
              <Grid item md={3}>
  <Autocomplete
    size="small"
    options={supplier}
    // options={[{ id: 0, fullname: "All" }, ...supplier]}
    value={selectedCustomer}
    onChange={(e, value) => {
      setSelectedCustomer(value);
      handleOptions(value, "customer");
    }}
    getOptionLabel={(option) => option.fullname || ""}
    disabled={roleId != 1 && roleId != 2}
    renderInput={(params) => (
      <TextField {...params} label="Select Outlet" />
    )}
    isOptionEqualToValue={(option, value) => option.id === value?.id}
  />
</Grid>

    </Grid>
  );
};

export default memo(SalesInfo);
